module.exports = __webpack_public_path__ + "img/pantalla-7-6.d272b1c2.png";